import React, { useEffect } from 'react';
import './SiteLinksModal.css';

const SiteLinksModal = ({
    isOpen,
    onClose,
    links,
    animeName,
    type = 'watch'
}) => {
    // Handle escape key press
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            // Prevent scrolling when modal is open
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    const handleSiteClick = (link) => {
        // Encode anime name for URL
        const encodedName = encodeURIComponent(animeName);
        const fullUrl = `${link.baseUrl}${encodedName}`;

        window.open(fullUrl, '_blank');

        // Close modal after opening link
        onClose();
    };

    if (!isOpen) return null;

    const title = type === 'read' ? '📖 Read' : '🎬 Watch';

    return (
        <div className="site-links-modal-overlay" onClick={onClose}>
            <div className="site-links-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 className="modal-title">{title} {animeName}</h2>
                    <button className="modal-close-btn" onClick={onClose} aria-label="Close">
                        ✕
                    </button>
                </div>
                <p className="modal-hint">You can add {type === 'read' ? 'read' : 'watch'} sites from the Settings.</p>
                <div className="modal-body">
                    {links.length === 0 ? (
                        <p className="no-links-message">
                            No {type === 'read' ? 'read' : 'watch'} links configured. Add them in Settings.
                        </p>
                    ) : (
                        <div className="site-links-grid">
                            {links.map((link) => (
                                <button
                                    key={link.id}
                                    className="site-link-btn"
                                    onClick={() => handleSiteClick(link)}
                                >
                                    <span className="site-link-icon">🔗</span>
                                    <span className="site-link-name">{link.name}</span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SiteLinksModal;
